<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="1.500em"
  height="1.500em"
  aria-hidden="true"
  focusable="false"
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20 12l-4.9-7h-2.2723l4.20001 6H4l1 2H17.02771l-4.20001 6H15.1L20 12z"
  /></svg
>
